import JsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { formatAccounting } from '../lib/utils'

export default function generateSaleReceiptPDF(receipt) {
  const doc = new JsPDF()

  // FORMATTERS
  const formatDate = (date) => {
    if (!date) return '-'

    return new Date(date).toLocaleDateString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  const formatTimestamp = (date) => {
    if (!date) return '-'

    return new Date(date).toLocaleString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  }

  // HEADER
  doc.setFontSize(20)
  doc.setFont(undefined, 'bold')
  doc.text(process.env.VUE_APP_CLIENT_NAME || 'LBPOULTRY', 14, 18)

  doc.setFontSize(16)
  doc.text('Sale Invoice', 14, 28)

  doc.setFont(undefined, 'normal')
  doc.setFontSize(11)

  // DETAILS
  const details = [
    ['Receipt No', receipt.receipt_no || '-'],
    ['Consumer', receipt.consumer_name || '-'],
    ['Store', receipt.store?.name || '-'],
    ['Date', formatDate(receipt.date_sold)],
    ['Timestamp', formatTimestamp(receipt.created_at)],
  ]

  autoTable(doc, {
    startY: 35,
    body: details,
    theme: 'plain',
    styles: {
      fontSize: 10,
      cellPadding: 1.5,
    },
    columnStyles: {
      0: {
        fontStyle: 'bold',
        cellWidth: 35,
      },
    },
  })

  // ITEMS TABLE
  const tableRows = receipt.items.map((item, index) => [
    index + 1,
    item.stock?.stock_code || '-',
    item.stock?.product_name || '-',
    item.unit || '-',
    item.quantity || 0,
    formatAccounting(item.retail || 0),
    formatAccounting(item.discount || 0),
    formatAccounting(item.amount || 0),
  ])

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 10,
    head: [
      ['#', 'Code', 'Item', 'Unit', 'Qty', 'Retail', 'Discount', 'Amount'],
    ],
    body: tableRows,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [41, 128, 185],
    },
    columnStyles: {
      4: { halign: 'center' },
      5: { halign: 'right' },
      6: { halign: 'right' },
      7: { halign: 'right' },
    },
  })

  // TOTAL
  doc.setFontSize(11)
  doc.setFont(undefined, 'bold')

  doc.text(
    `Total: ${formatAccounting(receipt.total_amount || 0)}`,
    14,
    doc.lastAutoTable.finalY + 12,
  )

  // SAVE
  doc.save(`sale-receipt-${receipt.receipt_no || 'invoice'}.pdf`)
}
